import { ENV } from "../utils";

export class Country {
  baseApi = ENV.BASE_API;

  async getCountries(accessToken, active = undefined) {
    const params = new URLSearchParams();
    if (active !== undefined) params.append("active", active);
    const url = `${this.baseApi}/countries?${params.toString()}`;
    const response = await fetch(url, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async createCountry(accessToken, data) {
    const url = `${this.baseApi}/add-country`;
    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async updateCountry(accessToken, id, data) {
    const url = `${this.baseApi}/update-country/${id}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
      body: JSON.stringify(data),
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }

  async deleteCountry(accessToken, id) {
    const url = `${this.baseApi}/delete-country/${id}`;
    const response = await fetch(url, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const result = await response.json();
    if (response.status !== 200) throw result;
    return result;
  }
}
